// =============================================================================
//  Copyright   : 2022 semantics GmbH
//  Date        : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author      : Dirk Rothe
//  Worker      : $Author: d.rothe $
//  Revision    : $Rev: 156393 $
//  Purpose     : custom column definitions index fields
// =============================================================================
// ---Third-party imports
import React from 'react'

// ---Framework imports
import {dict} from 'ldash'
import {registerColumnTypes, ColumnTypeNames as $} from 'uix/db/columnTypes'
import log from 'uix/logging'
import {DomainLabel} from 'uix/domain/label'

// ---Local imports

// ---Globals

registerColumnTypes({
  DomainListColumn: (env, colid, options) => ({
    Cell: ({value}) => {
      if (!value) return ''
      let odids = value.split(' ').map(odid => parseInt(odid))
      return (
        <span>
          {odids.map(odid => (
            <DomainLabel key={odid} odid={odid} style={{paddingLeft: '3px'}} />
          ))}
        </span>
      )
    },
    aggregate: vals => '',
  }),
})

export const columns = [[$.DomainListColumn, 'idx.domains', {i18nKey: 'Domains', acl: 'g:debug'}]]
